import {
  TEMPLATE_UPDATE_TEMPLATE_BEGIN,
  TEMPLATE_UPDATE_TEMPLATE_SUCCESS,
  TEMPLATE_UPDATE_TEMPLATE_FAILURE,
  TEMPLATE_UPDATE_TEMPLATE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateTemplate(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: TEMPLATE_UPDATE_TEMPLATE_BEGIN,
    });

    const { projectId, version, templateId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const config = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates/${templateId}/content`,
        args.values,
        config,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: TEMPLATE_UPDATE_TEMPLATE_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: TEMPLATE_UPDATE_TEMPLATE_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Updation Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: TEMPLATE_UPDATE_TEMPLATE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Updation Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateTemplateError() {
  return {
    type: TEMPLATE_UPDATE_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_UPDATE_TEMPLATE_BEGIN:
      return {
        ...state,
        updateTemplatePending: true,
        updateTemplateError: null,
      };

    case TEMPLATE_UPDATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        updateTemplatePending: false,
        updateTemplateError: null,
        template: action.data,
      };

    case TEMPLATE_UPDATE_TEMPLATE_FAILURE:
      return {
        ...state,
        updateTemplatePending: false,
        updateTemplateError: action.data.error,
      };

    case TEMPLATE_UPDATE_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        updateTemplateError: null,
      };

    default:
      return state;
  }
}
